import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Section from '../components/common/Section';
import QueryListView from '../components/queries/QueryListView';
import { selectUserData } from '../store/user';
import {getApprovedContracts, selectApprovedContracts, selectIsFetchingApprovedContracts, selectApprovedContractsSearchString} from '../store/query';
import { ROLE } from '../constants';
import { APP_COLORS, pageStyles } from '../styles';
import {  Outlet } from 'react-router-dom';

export default function ApprovedContracts({ }) {
  const dispatch = useDispatch();
  let role = useSelector(selectUserData).role;
  let searchString = useSelector(selectApprovedContractsSearchString); 
  
  let approvedContracts = useSelector(selectApprovedContracts);
  let isFetchingApprovedContracts = useSelector(selectIsFetchingApprovedContracts);
  
  useEffect(() => {
      if (role && (role == ROLE.Admin || role == ROLE.Management || ROLE.Contractor)) {
      dispatch(getApprovedContracts())
    }
  }, [])

  const onSearchEnter= (queryString) => {
    console.log('Approved COntracts', queryString)
    dispatch(getApprovedContracts(queryString))
  }


  return (<div style={{ ...pageStyles, ...styles.container }}>
      <Section
        title={'Pending Contracts'}
        content={
          <>
          { approvedContracts && 
          <QueryListView 
          role={role} 
          data={approvedContracts}  
          isFetching = {isFetchingApprovedContracts}
          onSearchEnter = {onSearchEnter}
          searchString = {searchString}
          />}
          <Outlet/>
          </>
        }
      />

  </div>)
}


const styles = {
  container: {

  },
}
